(ns hypnos.backoffice.tile.field.anatomy-iris
  "Field for the iris diameter."
  (:require [clojure.string :as str]
            [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/iris)]]
    [:div.field-body
     [:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/diameter)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       3
          :width      3
          :max-length 2
          :disabled   disabled
          :value      (when-let [val (get-in @state [:anatomy :anatomy/iris-diameter])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              new-value (when-not (str/blank? val) (int val))]
                          (swap! state assoc-in
                                 [:anatomy :anatomy/iris-diameter]
                                 new-value)))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/mm)]]]]]]))
